import { jsx as _jsx } from "react/jsx-runtime";
import { Column } from 'seagull';
import styles from './MessageFrame.module.scss';
export const MessageFrame = (param)=>{
    let { children, testId } = param;
    return /*#__PURE__*/ _jsx(Column, {
        gap: 12,
        padding: 16,
        width: "100%",
        className: styles.frame,
        testId: testId,
        children: children
    });
};
